"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientShow = clientShow;
exports.show = show;
exports.showMobile = showMobile;
exports.default = exports.AnimatedContainer = exports.MobileSiteNavigation = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _search = babelHelpers.interopRequireWildcard(require("modals/search"));

var _Button = babelHelpers.interopRequireDefault(require("components/Notifications/Button"));

var _Listener = babelHelpers.interopRequireDefault(require("components/Notifications/Listener"));

var _UserProfile = babelHelpers.interopRequireDefault(require("components/UserProfile"));

var _logout = require("logout");

var _LoginForm = require("components/LoginForm");

var _userProfile = require("user-profile");

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _noty = require("noty");

var _PaymentsModal = require("components/PaymentsModal");

var _PaymentMethodsModal = require("components/PaymentMethodsModal");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _eventDispatcher = babelHelpers.interopRequireDefault(require("event-dispatcher"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _Viewer = require("components/Notifications/Viewer");

var _localize = require("localize");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp, _class3, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _temp2, _class5, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _temp3;

function clientShow(props) {
  show(document.querySelector('#nav-container'), props);
}

function show(parent, props) {
  _reactDom.default.render(_react.default.createElement(SiteNavigation, props), parent);
}

function showMobile(parent, props) {
  _reactDom.default.render(_react.default.createElement(MobileSiteNavigation, props), parent);
}

var MobileSiteNavigation = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(MobileSiteNavigation, _Component);

  function MobileSiteNavigation() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, MobileSiteNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(MobileSiteNavigation)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "signUpText", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "signInText", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "userProfile", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "hasCreateAccount", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      profile: _this.userProfile
    };
    return _this;
  }

  babelHelpers.createClass(MobileSiteNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      $(document).on('profileUpdated', function (event) {
        _this2.setState({
          profile: event.profile
        });
      });
      if (!this.state.profile) this.updateProfile(null);
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(state) {
      var _this3 = this;

      if (state && state.modal) state.modal.hide();

      if (state && state.useCustomHome && location.href.split('?').shift() == state.defaultHome) {
        if (history.pushState) {
          history.pushState({}, "", state.useCustomHome);
        }
      }

      (0, _userProfile.userProfileUpdated)(state && state.loggedOut === true).then(function (profile) {
        if (state) {
          var evt;
          if (state.isNewAccount === true) evt = 'account-created';else if (state.isNewAccount === false) evt = 'signed-in';

          if (evt) {
            (0, _eventDispatcher.default)(evt, profile);
          }
        }

        _this3.setState(function (st) {
          return {
            profile: profile,
            menuOpen: st.menuOpen === true || st.menuOpen === false ? false : null
          };
        });
      });
    }
  }, {
    key: "logout",
    value: function logout(event) {
      (0, _logout.doLogout)().then(this.loggedOut).then(this.updateProfile);
    }
  }, {
    key: "loggedOut",
    value: function loggedOut(value) {
      (0, _noty.showNotificationText)('You have been signed out.');
      return {
        loggedOut: true
      };
    }
  }, {
    key: "showSignUp",
    value: function showSignUp(event) {
      _SiteLayout.default.current.hideSideNav();

      (0, _LoginForm.show)('sign-up').then(this.updateProfile);
    }
  }, {
    key: "showSignIn",
    value: function showSignIn(event) {
      _SiteLayout.default.current.hideSideNav();

      (0, _LoginForm.show)('sign-in').then(this.updateProfile);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.profile && !this.state.profile.guest) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "mobile-button-container"
      }, _react.default.createElement("a", {
        title: "Sign In",
        className: "mobile-btn sign-in",
        href: "javascript:void(0)",
        onClick: this.showSignIn
      }, _react.default.createElement("p", null, this.signInText || 'Sign In')), this.hasCreateAccount && _react.default.createElement("a", {
        title: "Sign Up",
        className: "mobile-btn sign-up",
        href: "javascript:void(0)",
        onClick: this.showSignUp
      }, _react.default.createElement("p", null, this.signUpText || 'Sign Up')));
    }
  }]);
  return MobileSiteNavigation;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "signUpText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "signInText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "userProfile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "hasCreateAccount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "updateProfile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "updateProfile"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "logout", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "loggedOut", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "loggedOut"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showSignUp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showSignUp"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showSignIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showSignIn"), _class.prototype)), _class);
exports.MobileSiteNavigation = MobileSiteNavigation;
var AnimatedContainer = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(AnimatedContainer, _Component2);

  function AnimatedContainer() {
    var _babelHelpers$getProt2;

    var _this4;

    babelHelpers.classCallCheck(this, AnimatedContainer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(AnimatedContainer)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "speed", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "delayEnter", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "delayExit", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "entrance", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "exit", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "style", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "mode", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "children", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "className", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "id", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    _this4.state = {
      // Current: out, entering, in, exiting
      current: 'out',
      // Target: out, in
      target: 'out'
    };
    return _this4;
  }

  babelHelpers.createClass(AnimatedContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.mode == 'in') {
        this.setState({
          target: 'in'
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.mode != this.props.mode) {
        switch (this.mode) {
          case 'out':
          default:
            this.setState({
              target: 'out'
            });
            break;

          case 'in':
            this.setState({
              target: 'in'
            });
            break;
        }
      }

      if (this.state.current != 'entering' && this.state.current != 'exiting') {
        if (this.state.current != this.state.target) {
          this.run();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.animator) {
        this.animator.stop();
      }

      if (this.animatorDelay) clearTimeout(this.animatorDelay);
    }
  }, {
    key: "gotAnimationRoot",
    value: function gotAnimationRoot(node) {
      this.animationRoot = node;
    }
  }, {
    key: "run",
    value: function run() {
      var _this5 = this;

      this.setState(function (state) {
        if (state.target == 'in') return {
          current: 'entering'
        };
        return {
          current: 'exiting'
        };
      }, function () {
        _this5.animator = new _animationHelper.default(_this5.speed, _this5.state.current == 'entering' ? _this5.entrance : _this5.exit, function (percent) {
          var pct = _this5.state.current == 'entering' ? percent : 1 - percent;

          _this5.setStyles(_this5.style(_this5.animationRoot, pct));
        }, function () {
          _this5.setStyles(_this5.style(_this5.animationRoot, _this5.state.current == 'entering' ? 1 : 0));

          _this5.animator = null;

          _this5.setState(function (st) {
            return {
              current: st.current == 'entering' ? 'in' : 'out'
            };
          });
        });
        var w = _this5.state.current == 'entering' ? 'delayEnter' : 'delayExit';
        _this5.animatorDelay = setTimeout(function () {
          return _this5.animator.start();
        }, _this5[w]); // this.animator.start();
      });
    }
  }, {
    key: "setStyles",
    value: function setStyles(style) {
      if (this.animationRoot) {
        for (var i in style) {
          this.animationRoot.style[i] = style[i];
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.className,
        id: this.id,
        ref: this.gotAnimationRoot
      }, this.state.current == 'out' && this.state.target == 'out' ? null : this.children);
    }
  }], [{
    key: "test",
    value: function test() {
      return {
        _node: document.createElement('div'),
        attach: function attach() {
          document.body.appendChild(this._node);
          Object.assign(this._node.style, {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '500px',
            height: '500px',
            background: '#fff',
            color: '#000',
            padding: '16px'
          });

          _reactDom.default.render(_react.default.createElement(AnimatedContainer, {
            mode: "out",
            style: function style(node, percent) {
              return {
                opacity: percent
              };
            }
          }, _react.default.createElement("div", null, "Hello world!")), this._node);
        },
        enter: function enter() {
          _reactDom.default.render(_react.default.createElement(AnimatedContainer, {
            mode: "in",
            style: function style(node, percent) {
              return {
                opacity: percent
              };
            }
          }, _react.default.createElement("div", null, "Hello world!")), this._node);
        },
        exit: function exit() {
          _reactDom.default.render(_react.default.createElement(AnimatedContainer, {
            mode: "out",
            style: function style(node, percent) {
              return {
                opacity: percent
              };
            }
          }, _react.default.createElement("div", null, "Hello world!")), this._node);
        },
        detach: function detach() {
          _reactDom.default.unmountComponentAtNode(this._node);

          document.body.removeChild(this._node);
        }
      };
    }
  }]);
  return AnimatedContainer;
}(_react.Component), _temp2), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "speed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 300;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "delayEnter", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "delayExit", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "entrance", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'ease-in';
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "exit", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'ease-out';
  }
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "style", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (node, percent) {
      return {};
    };
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "mode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'out';
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "gotAnimationRoot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "gotAnimationRoot"), _class3.prototype)), _class3);
exports.AnimatedContainer = AnimatedContainer;
var SiteNavigation = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(SiteNavigation, _Component3);

  function SiteNavigation() {
    var _babelHelpers$getProt3;

    var _this6;

    babelHelpers.classCallCheck(this, SiteNavigation);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(SiteNavigation)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "searchButton", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "notificationButton", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "userProfile", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "loginPrefix", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "signUpText", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "signInText", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "hasSearch", _descriptor21, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "hasCreateAccount", _descriptor22, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "menuToggle", _descriptor23, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "showBackButton", _descriptor24, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "hasPrevious", _descriptor25, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    _this6.state = {
      profile: _this6.userProfile,
      menuOpen: null,
      notificationsOpen: false,
      navDown: true,
      navTop: 0,
      hasPaymentMethods: null,
      profileChanged: true,
      profileWithStatus: null,
      pendingAssignments: null,
      pendingEvents: null,
      pendingApplications: null
    };
    _this6.lastScrollPosition = 0;
    return _this6;
  }

  babelHelpers.createClass(SiteNavigation, [{
    key: "updateAssignments",
    value: function updateAssignments() {
      var _this7 = this;

      if (this._updateAssignmentTimer) return;
      this._updateAssignmentTimer = setTimeout(function () {
        (0, _fetch.default)('data/notifications/instructorfeed').then(function (value) {
          return value.json();
        }).then(function (value) {
          _this7.setState({
            pendingAssignments: _this7.filterFeed(value, function (item) {
              return /^grading/.test(item.id);
            }),
            pendingEvents: _this7.filterFeed(value, function (item) {
              return /^event/.test(item.id);
            }),
            pendingApplications: _this7.filterFeed(value, function (item) {
              return /^application/.test(item.id);
            })
          });

          _this7._updateAssignmentTimer = null;
        });
      }, 250);
    }
  }, {
    key: "filterFeed",
    value: function filterFeed(inFeed, itemCallback) {
      var feed = inFeed.feed,
          items = inFeed.items,
          outObject = babelHelpers.objectWithoutProperties(inFeed, ["feed", "items"]);
      outObject.feed = feed.filter(itemCallback);
      var ids = outObject.feed.map(function (item) {
        return item.id;
      });
      outObject.items = items.filter(function (item) {
        return ids.indexOf(item.id) != -1;
      });
      return outObject;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this8 = this;

      $(document).on('profileUpdated', function (event) {
        if (event.passedState) {
          var state = event.passedState;
          var evt;
          if (state.isNewAccount === true) evt = 'account-created';else if (state.isNewAccount === false) evt = 'signed-in';

          if (evt) {
            (0, _eventDispatcher.default)(evt, profile);
          }
        }

        _this8.setState(function (st) {
          return {
            profile: event.profile,
            profileChanged: true,
            menuOpen: st.menuOpen === true || st.menuOpen === false ? false : null,
            pendingAssignments: null,
            pendingEvents: null,
            pendingApplications: null
          };
        });

        _this8.updateAssignments();
      });

      if (!this.state.profile) {
        this.updateProfile(null);
      }

      document.addEventListener('scroll', this.onScroll, {
        passive: false
      });
      this.lastScrollPosition = Math.max(0, (document.scrollingElement || document.documentElement).scrollTop || document.body.scrollTop);
      this.onScroll();
      ['documentSubmitted', 'eventTimeComment', 'eventTimeRejected', 'eventTimeAccepted', 'eventTimeSuggested', 'videoSubmitted', 'applicationSubmitted'].forEach(function (event) {
        _Listener.default.addEventListener(event, _this8.updateAssignments);

        _Listener.default.addEventListener("updated-".concat(event), _this8.updateAssignments);

        _Listener.default.addEventListener("removed-".concat(event), _this8.updateAssignments);
      });
      this.updateAssignments();
    }
  }, {
    key: "onScroll",
    value: function onScroll(event) {
      var currentNavTop = this.state.navTop;
      if (this.state.isAnimated) currentNavTop = this.state.targetNavTop;
      var currentNavBottom = currentNavTop + this.navContainer.offsetHeight;
      var scrollPosition = (document.scrollingElement || document.documentElement).scrollTop || document.body.scrollTop;
      scrollPosition = Math.max(0, scrollPosition); // We've moved down the screen. Don't move the nav bar, or if it's already moving, let it keep going.

      if (scrollPosition > this.lastScrollPosition) {
        // Don't move it.
        this.lastScrollPosition = scrollPosition;
        return;
      } // So we're going up. If it's needing to be animated in, or it's currently being animated in, just change the target poiint.


      if (currentNavBottom < scrollPosition || this.state.isAnimated) {
        // This is a pop-in effect.
        this.setState({
          isAnimated: true,
          targetNavTop: scrollPosition
        });
      } else if (currentNavTop > scrollPosition) {
        // This is a move.
        this.setState({
          navTop: scrollPosition
        });
      }

      this.lastScrollPosition = scrollPosition;
    }
  }, {
    key: "showMenu",
    value: function showMenu(event) {
      this.setState(function (st) {
        return {
          menuOpen: !st.menuOpen
        };
      });
    }
  }, {
    key: "showSearch",
    value: function showSearch(event) {
      _search.default.show();

      event.preventDefault();
      return false;
    }
  }, {
    key: "showNotifications",
    value: function showNotifications(event) {
      event.preventDefault();
      return false;
    }
  }, {
    key: "showProfile",
    value: function showProfile(event) {
      if (this.state.menuOpen) {
        _UserProfile.default.show();

        event.preventDefault();
        return false;
      }
    }
  }, {
    key: "logout",
    value: function logout(event) {
      if (this.state.menuOpen) (0, _logout.doLogout)().then(this.loggedOut).then(this.updateProfile);
    }
  }, {
    key: "loggedOut",
    value: function loggedOut(value) {
      (0, _noty.showNotificationText)('You have been signed out.');
      return {
        loggedOut: true
      };
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(state) {
      var _this9 = this;

      if (state && state.modal) state.modal.hide();

      if (state && state.useCustomHome && location.href.split('?').shift() == state.defaultHome) {
        if (history.pushState) {
          history.pushState({}, "", state.useCustomHome);
        }
      }

      (0, _userProfile.userProfileUpdated)(state && state.loggedOut === true).then(function (profile) {
        if (state) {
          var evt;
          if (state.isNewAccount === true) evt = 'account-created';else if (state.isNewAccount === false) evt = 'signed-in';

          if (evt) {
            (0, _eventDispatcher.default)(evt, profile);
          }
        }

        _this9.setState(function (st) {
          return {
            profile: profile,
            menuOpen: st.menuOpen === true || st.menuOpen === false ? false : null
          };
        });
      });
    }
  }, {
    key: "showSignUp",
    value: function showSignUp(event) {
      (0, _LoginForm.show)('sign-up').then(this.updateProfile);
    }
  }, {
    key: "showSignIn",
    value: function showSignIn(event) {
      (0, _LoginForm.show)('sign-in').then(this.updateProfile);
    }
  }, {
    key: "showCourses",
    value: function showCourses(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.MyCourses.show();
    }
  }, {
    key: "showCollections",
    value: function showCollections(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Collections.show();
    }
  }, {
    key: "showSubmissions",
    value: function showSubmissions(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Submissions.show();
    }
  }, {
    key: "showFavorites",
    value: function showFavorites(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Favorites.show();
    }
  }, {
    key: "showGroups",
    value: function showGroups(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Groups.show();
    }
  }, {
    key: "showEvents",
    value: function showEvents(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Events.show();
    }
  }, {
    key: "showFollowing",
    value: function showFollowing(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Following.show();
    }
  }, {
    key: "showRewards",
    value: function showRewards(event) {
      if (this.state.menuOpen && 'count' in event.target.dataset && event.target.dataset.count != '0') {
        var tgt = event.target.dataset.id;
        var item = this.state.profileWithStatus.status.rewardItems.filter(function (item) {
          return item.id == tgt;
        })[0];

        _search.RewardsModal.modalForId(item.id, item.title, item.icon).show();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this10 = this;

      if (prevState.menuOpen != this.state.menuOpen) {
        if (this.state.menuOpen) {
          document.addEventListener('click', this.documentClicked);

          if (this.state.hasPaymentMethods === null) {
            (0, _fetch.default)('purchase/stripe/account').then(function (result) {
              return result.json();
            }).then(function (result) {
              if (_this10.requireAddress) {
                var x = Object.assign({}, result);
                x.sources = x.sources.filter(function (source) {
                  return source.owner && source.owner.address && source.owner.address.line1;
                });
                if (x.sources.filter(function (v) {
                  return v.id == x.defaultSource;
                }).length == 0) x.defaultSource = null;
                result = x;
              }

              if (result.sources.length) {
                _this10.setState({
                  hasPaymentMethods: true
                });
              } else {
                _this10.setState({
                  hasPaymentMethods: false
                });
              }
            });
          }
        } else {
          document.removeEventListener('click', this.documentClicked);
        }
      }

      if (!prevState.isAnimated && this.state.isAnimated) {
        this.animation = new _animationHelper.default(300, 'ease-in', function (pct) {
          var tp = _this10.state.targetNavTop - _this10.navContainer.offsetHeight * (1 - pct);

          _this10.setState({
            navTop: tp
          });
        }, function () {
          _this10.animation = null;

          _this10.setState(function (st) {
            return {
              isAnimated: false,
              navTop: st.targetNavTop
            };
          });
        });
        this.animation.start();
      } else if (this.animation && !this.state.isAnimated) {
        this.animation.stop();
      }

      if (this.state.menuOpen && this.state.profileChanged) {
        this.updateProfileStatus();
      }
    }
  }, {
    key: "updateProfileStatus",
    value: function updateProfileStatus() {
      var _this11 = this;

      (0, _fetch.default)('userProfile').then(function (r) {
        return r.json();
      }).then(function (r) {
        return _this11.setState({
          profileWithStatus: r,
          profileChanged: false
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this12 = this;

      if (this.state.menuOpen) {
        document.removeEventListener('click', this.documentClicked);
      }

      ['documentSubmitted', 'eventTimeComment', 'eventTimeRejected', 'eventTimeAccepted', 'eventTimeSuggested', 'videoSubmitted', 'applicationSubmitted'].forEach(function (event) {
        _Listener.default.removeEventListener(event, _this12.updateAssignments);

        _Listener.default.removeEventListener("updated-".concat(event), _this12.updateAssignments);

        _Listener.default.removeEventListener("removed-".concat(event), _this12.updateAssignments);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if ('top' in newProps && 'top' in this.props && this.props.top != newProps.top) {
        this.setState({
          navTop: newProps.top
        });
      }
    }
  }, {
    key: "documentClicked",
    value: function documentClicked(event) {
      this.setState({
        menuOpen: false
      });
    }
  }, {
    key: "gotNavContainer",
    value: function gotNavContainer(node) {
      this.navContainer = node;
    }
  }, {
    key: "showPayments",
    value: function showPayments() {
      if (this.state.menuOpen) (0, _PaymentsModal.show)();
    }
  }, {
    key: "showPaymentMethods",
    value: function showPaymentMethods() {
      if (this.state.menuOpen) {
        (0, _PaymentMethodsModal.show)();
      }
    }
  }, {
    key: "showApplications",
    value: function showApplications() {
      if (this.state.menuOpen) new _Viewer.InstructorNotificationViewer(function (item) {
        return /^application/.test(item.id);
      }, 'Applications', 'ballot').show();
    }
  }, {
    key: "showGrading",
    value: function showGrading() {
      if (this.state.menuOpen) new _Viewer.InstructorNotificationViewer(function (item) {
        return /^grading/.test(item.id);
      }, 'Assignments', 'grading').show();
    }
  }, {
    key: "showPendingEvents",
    value: function showPendingEvents() {
      if (this.state.menuOpen) new _Viewer.InstructorNotificationViewer(function (item) {
        return /^event/.test(item.id);
      }, 'Events', 'events').show();
    }
  }, {
    key: "goBack",
    value: function goBack() {
      history.back();
    }
  }, {
    key: "getBackButtonStyle",
    value: function getBackButtonStyle(node, percent) {
      return {
        transform: "translateX(".concat(percent * 100, "%)")
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "navigation-placeholder"
      }, _react.default.createElement("div", {
        className: _classList.default.join('navigation-container', this.state.navTop < 10 ? '' : 'scrolled'),
        ref: this.gotNavContainer,
        style: {
          top: this.state.navTop + 'px'
        }
      }, _react.default.createElement("div", {
        className: "nav-left"
      }, _react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "menu-icon",
        onClick: this.menuToggle
      }, _react.default.createElement("img", {
        src: this.props.menuButton
      })), _react.default.createElement(AnimatedContainer, {
        delayEnter: 300,
        delayExit: 300,
        mode: this.props.hasPrevious && this.props.showBackButton ? 'in' : 'out',
        className: "back-button-container",
        style: this.getBackButtonStyle
      }, _react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "back-button",
        onClick: this.goBack
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "arrow_back"
      }), "Go Back"))), _react.default.createElement("div", {
        className: "nav-logo center"
      }, _react.default.createElement("a", {
        href: this.props.homeLink
      }, _react.default.createElement("img", {
        className: "logo desktop",
        src: this.props.desktopLogo,
        alt: this.props.companyName
      }), _react.default.createElement("img", {
        className: "logo mobile",
        src: this.props.mobileLogo,
        alt: this.props.companyName
      }))), this.renderSiteNav()));
    }
  }, {
    key: "showInstructorTools",
    value: function showInstructorTools() {
      var x = (this.state.pendingAssignments || {
        items: []
      }).items.length;
      x += (this.state.pendingEvents || {
        items: []
      }).items.length;
      x += (this.state.pendingApplications || {
        items: []
      }).items.length;
      return x > 0;
    }
  }, {
    key: "renderSiteNav",
    value: function renderSiteNav() {
      var _this13 = this;

      if (this.state.profile && !this.state.profile.guest) {
        return _react.default.createElement("div", {
          className: "nav-right"
        }, _react.default.createElement("div", null, this.hasSearch && _react.default.createElement("a", {
          title: "Search",
          className: "icon search",
          href: "javascript:void(0)",
          onClick: this.showSearch
        }, _react.default.createElement("span", {
          className: "material-icons",
          "data-icon": "search"
        }), _react.default.createElement("span", {
          className: "sr-only"
        }, "Search")), false && _react.default.createElement(_Button.default, {
          notificationButton: this.notificationButton
        }), _react.default.createElement(_localize.LocalizeMenu, null), _react.default.createElement("a", {
          title: "My Account",
          id: "myAccountLink",
          className: _classList.default.join('icon', 'menu', this.state.profile.photo ? 'image' : '', this.state.menuOpen ? 'open' : ''),
          href: "javascript:void(0)",
          onClick: this.showMenu,
          style: Object.assign({}, this.state.profile.photo ? {
            backgroundImage: "url(".concat(this.state.profile.photo, ")")
          } : {})
        }, _react.default.createElement("p", null, (this.state.profile.nickname || this.state.profile.fullName).split(/\s+/).map(function (v) {
          return v.charAt(0);
        }).join(''))), _react.default.createElement("div", {
          className: _classList.default.join('nav-dropdown', this.state.menuOpen ? 'open' : '', this.state.menuOpen === false ? 'closed' : '')
        }, _react.default.createElement("div", {
          className: "top"
        }, _react.default.createElement("p", {
          className: "name",
          id: "myAccountName"
        }, this.state.profile.nickname || this.state.profile.fullName)), _react.default.createElement("div", {
          className: "middle"
        }, this.state.profile.system.hasCourses && _react.default.createElement("a", {
          className: "menu-item2 courses",
          onClick: this.showCourses,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.courseCount,
          href: "javascript:void(0)"
        }, "Courses"), this.state.profile.system.hasCollections && _react.default.createElement("a", {
          className: "menu-item2 collections",
          onClick: this.showCollections,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.collectionCount,
          href: "javascript:void(0)"
        }, "Collections"), this.state.profile.system.hasSubmissions && _react.default.createElement("a", {
          className: "menu-item2 submissions",
          onClick: this.showSubmissions,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.submissionCount,
          href: "javascript:void(0)"
        }, "Submissions"), this.state.profile.system.hasEvents && _react.default.createElement("a", {
          className: "menu-item2 events",
          onClick: this.showEvents,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.eventsCount || 0,
          href: "javascript:void(0)"
        }, "Events"), this.state.profile.system.hasFollowing && _react.default.createElement("a", {
          className: "menu-item2 following",
          onClick: this.showFollowing,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.followingCount || 0,
          href: "javascript:void(0)"
        }, "Following"), _react.default.createElement("a", {
          className: "menu-item2 favorites",
          onClick: this.showFavorites,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.favoriteCount,
          href: "javascript:void(0)"
        }, "Favorites"), this.state.profile.system.hasUserGroups && this.state.profileWithStatus && !!this.state.profileWithStatus.status.groupCount && _react.default.createElement("a", {
          className: "menu-item2 groups",
          onClick: this.showGroups,
          "data-count": this.state.profileWithStatus.status.groupCount,
          href: "javascript:void(0)"
        }, "Groups"), (this.state.profileWithStatus || {
          status: {
            rewardItems: []
          }
        }).status.rewardItems.map(function (item) {
          return _react.default.createElement("a", {
            key: item.id,
            className: _classList.default.join('menu-item2', item.icon.type == 'system' ? item.icon.className : 'user-icon'),
            "data-count": item.itemCount,
            href: "javascript:void(0)",
            "data-id": item.id,
            onClick: _this13.showRewards
          }, item.title);
        })), this.showInstructorTools() && _react.default.createElement("div", {
          className: "middle2"
        }, _react.default.createElement("div", {
          className: "top"
        }, _react.default.createElement("p", {
          className: "name"
        }, "Instructor Tools")), this.state.pendingAssignments && this.state.pendingAssignments.items.length > 0 && _react.default.createElement("a", {
          className: "menu-item2 grading",
          onClick: this.showGrading,
          "data-count": this.state.pendingAssignments.items.length,
          href: "javascript:void(0)"
        }, "Assignments"), this.state.pendingEvents && this.state.pendingEvents.items.length > 0 && _react.default.createElement("a", {
          className: "menu-item2 events",
          onClick: this.showPendingEvents,
          "data-count": this.state.pendingEvents.items.length,
          href: "javascript:void(0)"
        }, "Events"), this.state.pendingApplications && this.state.pendingApplications.items.length > 0 && _react.default.createElement("a", {
          className: "menu-item2 applications",
          onClick: this.showApplications,
          "data-count": this.state.pendingApplications.items.length,
          href: "javascript:void(0)"
        }, "Applications")), _react.default.createElement("div", {
          className: "bottom"
        }, _react.default.createElement("a", {
          className: "menu-item3 profile",
          href: "javascript:void(0)",
          onClick: this.showProfile
        }, "Profile"), this.state.profile.system.hasPurchases && _react.default.createElement("a", {
          className: "menu-item3 payment-methods",
          href: "javascript:void(0)",
          onClick: this.showPaymentMethods
        }, "Payment Methods"), this.state.profile.system.hasPurchases && _react.default.createElement("a", {
          className: "menu-item3 purchases",
          href: "javascript:void(0)",
          onClick: this.showPayments
        }, "Purchases"), _react.default.createElement("a", {
          className: "menu-item3 sign-out",
          href: "javascript:void(0)",
          onClick: this.logout
        }, "Sign Out")))));
      }

      return _react.default.createElement("div", {
        className: "nav-right"
      }, _react.default.createElement("div", null, this.hasCreateAccount && this.loginPrefix && _react.default.createElement("p", {
        className: "login-prefix"
      }, this.loginPrefix), _react.default.createElement("div", {
        className: "button-container"
      }, _react.default.createElement("a", {
        title: "Sign In",
        className: "sign-in",
        href: "javascript:void(0)",
        onClick: this.showSignIn
      }, _react.default.createElement("p", null, this.signInText || 'Sign In')), this.hasCreateAccount && _react.default.createElement("a", {
        title: "Sign Up",
        className: "sign-up",
        href: "javascript:void(0)",
        onClick: this.showSignUp
      }, _react.default.createElement("p", null, this.signUpText || 'Sign Up'))), this.hasSearch && _react.default.createElement("a", {
        title: "Search",
        className: "icon search",
        href: "javascript:void(0)",
        onClick: this.showSearch
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "search"
      }), _react.default.createElement("span", {
        className: "sr-only"
      }, "Search")), _react.default.createElement(_localize.LocalizeMenu, null)));
    }
  }]);
  return SiteNavigation;
}(_react.Component), _temp3), (_descriptor15 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "searchButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "notificationButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "userProfile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "loginPrefix", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "signUpText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "signInText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "hasSearch", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor22 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "hasCreateAccount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor23 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "menuToggle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showBackButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor25 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "hasPrevious", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "updateAssignments", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "updateAssignments"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "onScroll", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "onScroll"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showMenu", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showMenu"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSearch", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSearch"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showNotifications", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showNotifications"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showProfile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showProfile"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "logout", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "logout"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "loggedOut", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "loggedOut"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "updateProfile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "updateProfile"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSignUp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSignUp"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSignIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSignIn"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showCourses", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showCourses"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showCollections", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showCollections"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSubmissions", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSubmissions"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showFavorites", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showFavorites"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showGroups", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showGroups"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showEvents", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showEvents"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showFollowing", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showFollowing"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showRewards", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showRewards"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "documentClicked", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "documentClicked"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "gotNavContainer", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "gotNavContainer"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showPayments", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showPayments"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showPaymentMethods", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showPaymentMethods"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showApplications", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showApplications"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showGrading", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showGrading"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showPendingEvents", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showPendingEvents"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "goBack", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "goBack"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "getBackButtonStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "getBackButtonStyle"), _class5.prototype)), _class5);
exports.default = SiteNavigation;